import { useCallback, useEffect, useState } from "react";
import { CasPurposesApi } from "@jti/rest-api";
export const useQuizConsent = (quizData, uuid) => {
    const casPurposesApi = CasPurposesApi.init();
    const [consentData, setConsentData] = useState(null);
    const fetchConsentPurpose = useCallback(async () => {
        if (!uuid)
            return null;
        try {
            const purposes = await casPurposesApi.getPurposesForUserByStep("sob");
            const matchingPurpose = purposes.find((purpose) => purpose.id === quizData.consentCaptureQuestion.marketingMailConsentId);
            if (!matchingPurpose) {
                console.error("[DEBUG] No matching purpose found for consent ID:", quizData.consentCaptureQuestion.marketingMailConsentId);
                return null;
            }
            return matchingPurpose;
        }
        catch (error) {
            console.error("[DEBUG] CasAPI check failed:", error);
            return null;
        }
    }, [uuid, quizData.consentCaptureQuestion.marketingMailConsentId, casPurposesApi]);
    const checkConsent = useCallback(async () => {
        const purpose = await fetchConsentPurpose();
        if (purpose) {
            return purpose.accepted;
        }
        return null;
    }, [fetchConsentPurpose]);
    useEffect(() => {
        const initializeConsent = async () => {
            const purpose = await fetchConsentPurpose();
            if (purpose) {
                setConsentData({
                    name: purpose.name,
                    description: purpose.description,
                });
            }
        };
        initializeConsent();
    }, [uuid, quizData.consentCaptureQuestion.marketingMailConsentId]);
    const submitConsent = useCallback(async (hasConsent) => {
        if (!uuid)
            return false;
        const consentId = quizData?.consentCaptureQuestion?.marketingMailConsentId;
        if (!consentId) {
            console.error("Consent ID not found");
            return false;
        }
        try {
            await casPurposesApi.updateUserConsentsEvo({
                consents: [
                    {
                        id: consentId,
                        accepted: hasConsent,
                    },
                ],
            });
            return true;
        }
        catch (error) {
            console.error("Failed to update consent:", error);
            return false;
        }
    }, [uuid, quizData?.consentCaptureQuestion?.marketingMailConsentId, casPurposesApi]);
    return {
        consentData,
        submitConsent,
        checkConsent,
    };
};
//# sourceMappingURL=useQuizConsent.js.map